// const STATUS_MAP = {
//     "Barang telah di kirim career": "02",
//     "Delivered": "03"
// };

export const STATUS_MAP_BARANG = {
    "Package Prepared": "02",
    "Shipped": "03",
    "In Transit to Airport": "04",
    "Departed Indonesia": "05",
    "Arrived at Destination Airport": "06",
    "Customs Clearance": "07",
    "Out for Delivery": "08",
    "Delivered": "09"
};

export const STATUS_MAP_UANG_OUT = {
    "Funds Received": "02",
    "Processing": "03",
    "Sent to Correspondent Bank": "04",
    "Received by Correspondent Bank": "05",
    "Payout Processing": "06",
    "Paid Out": "07"
};

export const STATUS_MAP_UANG_IN = {
    "Funds Received by Correspondent Bank": "02",
    "Funds Sent to Indonesia": "03",
    "Received by Salam Service": "04",
    "Processing": "05",
    "Paid Out": "06"
}

export const STATUS_OPTION_BARANG = [
    { value: "Package Prepared"},
    { value: "Shipped"},
    { value: "In Transit to Airport"},
    { value: "Departed Indonesia"},
    { value: "Arrived at Destination Airport"},
    { value: "Customs Clearance"},
    { value: "Out for Delivery"},
    { value: "Delivered"}
];

export const STATUS_OPTION_UANG_OUT = [
    { value: "Funds Received"},
    { value: "Processing"},
    { value: "Sent to Correspondent Bank"},
    { value: "Received by Correspondent Bank"},
    { value: "Payout Processing"},
    { value: "Paid Out"}
];

export const STATUS_OPTION_UANG_IN = [
    { value: "Funds Received by Correspondent Bank"},
    { value: "Funds Sent to Indonesia"},
    { value: "Received by Salam Service"},
    { value: "Processing"},
    { value: "Paid Out"}
];